import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametreModuleDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreModuleDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalUpdate extends Vue {
    public parametrage: ParametreModuleDto = { Id: 0 };

    public Init(id: number): void {
        ServicesFactoryInstance.ParametrageModuleService.getParametrageModuleById(id, data => {
            this.parametrage = data;
        });
    }

    public update(): void {
        if (this.parametrage.IsSensitive && (!this.parametrage.StrData || this.parametrage.StrData.trim() === "")) {
            NotificationServiceInstance.SendFailed("La valeur d'un paramètre sensible (mot de passe, secret…) ne peut pas être vide.");

            return;
        }

        ServicesFactoryInstance.ParametrageModuleService.updateParametrageModule(this.parametrage, () => {
            NotificationServiceInstance.SendSuccess("Paramétrage modifié avec succès");
            this.$emit("refresh");
            this.annuler();
        });
    }

    public annuler(): void {
        $("#modalUpdate").modal("hide");
    }

    public get isValidationDisabled(): boolean {
        return !!this.parametrage.IsSensitive && this.isStrDataEmpty;
    }

    public get isStrDataEmpty(): boolean {
        return !this.parametrage.StrData || this.parametrage.StrData.trim() === "";
    }
}



// WEBPACK FOOTER //
// ./src/components/parametrageModule/modalUpdate/modalUpdate.ts